export const STOCK_OPNAME_REQUEST = 'STOCK_OPNAME_REQUEST'
export const GET_PRODUCT_OPTIONS_SUCCESS = 'GET_PRODUCT_OPTIONS_SUCCESS'
export const GET_PRODUCT_OPTIONS_ERROR = 'GET_PRODUCT_OPTIONS_ERROR'
export const GET_STOCK_OPNAME_CHECK_SUCCESS = 'GET_STOCK_OPNAME_CHECK_SUCCESS'
export const GET_STOCK_OPNAME_CHECK_ERROR = 'GET_STOCK_OPNAME_CHECK_ERROR'
export const STOCK_OPNAME_RESET = 'STOCK_OPNAME_RESET'
